import {Component, Input, OnInit} from '@angular/core';
import {WizardEventsService} from '../../../../../../services/wizard-events.service';

@Component({
    selector: 'lib-detalle-card',
    templateUrl: './detalle-card.component.html',
    styleUrls: ['./detalle-card.component.css']
})
export class DetalleCardComponent implements OnInit {

    @Input()
    nombreSeccion: string;

    @Input()
    titulo: string;

    constructor(private wizarEvents: WizardEventsService) {
    }

    verDetalle() {
        this.wizarEvents.gotToStepName(this.nombreSeccion);
    }

    ngOnInit(): void {
    }

}
